import { Component, OnInit } from '@angular/core';
import { PatientService } from 'src/app/services/patient.service';
import { UserConfigService } from 'src/app/services/user-config.service';
import { LegacyContentService } from 'src/app/services/legacy-content.service';

@Component({
  selector: 'app-menu-left',
  templateUrl: './menu-left.component.html',
  styleUrls: ['./menu-left.component.scss']
})
export class MenuLeftComponent implements OnInit {

  constructor(public patient: PatientService, public userConfig: UserConfigService, private legacyContent: LegacyContentService) { }

  ngOnInit(): void {
  }

  menuClick(menu)
  {
      if (typeof menu.execute !== 'undefined')
      {
          // tslint:disable-next-line:no-eval
          eval(menu.execute);
      }
      if (typeof menu.loadcontent !== 'undefined')
      {
          if (typeof menu.loadcontent === 'string')
          {
            this.legacyContent.LoadContent(menu.loadcontent);
          }
          else
          {
            this.legacyContent.LoadContent(menu.loadcontent[0], menu.loadcontent[1], menu.loadcontent[2]);
          }
      }
      if (typeof menu.pwa.content !== 'undefined') {
        this.legacyContent.SetComponent(menu.pwa.content);
      }
  }

}
